import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundaryReactRouter';
import { convertRouteModule } from '@/utils/convert-route-module';
import { RouteObject } from 'react-router';

import { AdminReportViewFallback } from './AdminReportView/AdminReportViewFallback';

const modalRoutes: RouteObject[] = [
  {
    path: 'awards',
    lazy: () => import('@/views/stickers/AwardStickersModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'award_all',
    lazy: () => import('@/views/stickers/AwardStickersModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'manage',
    lazy: () => import('@/views/stickers/ManageStickersModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'create',
    lazy: () => import('@/views/stickers/CreateStickerModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'redeem',
    lazy: () => import('@/views/stickers/RedeemStickersModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'report',
    lazy: () =>
      import('@/views/stickers/DownloadStickersReportModal/DownloadStickersReportModal').then(
        convertRouteModule
      ),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'reset',
    lazy: () => import('@/views/stickers/ResetStickersBalanceModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'avatar/:studentId',
    lazy: () =>
      import('@/views/stickers/components/UpdateStudentAvatarModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
];

// Section stickers modals need a `sectionId` param and must not mount under Award To Any.
const sectionModalRoutes: RouteObject[] = [...modalRoutes];

export const stickerRoutes: RouteObject[] = [
  {
    path: '/sections/:sectionId/stickers',
    lazy: () =>
      import('@/views/stickers/StickersClassView/StickersClassView').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
    children: [
      {
        path: '',
        lazy: () =>
          import('@/views/stickers/StickersDayView/StickersDayView').then(convertRouteModule),
        ErrorBoundary,
        HydrateFallback: () => null,
        children: sectionModalRoutes,
      },
      {
        path: 'week',
        lazy: () =>
          import('@/views/stickers/StickersWeekView/StickersWeekView').then(convertRouteModule),
        ErrorBoundary,
        HydrateFallback: () => null,
        children: sectionModalRoutes,
      },
    ],
  },
  // Declared before the Award To Any route so the static `report` segment is
  // not treated as one of its modal children.
  {
    path: '/schools/:schoolId/stickers/report',
    lazy: () => import('@/views/stickers/AdminReportView/AdminReportView').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: AdminReportViewFallback,
  },
  {
    path: '/schools/:schoolId/stickers',
    lazy: () => import('@/views/stickers/AwardToAnyView/AwardToAnyView').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
    children: modalRoutes,
  },
  {
    path: '/students/:studentId/stickers',
    lazy: () => import('@/views/stickers/StickersParentView').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
    children: [
      {
        path: ':awardId/note',
        lazy: () => import('@/views/stickers/StickerNoteModal').then(convertRouteModule),
        ErrorBoundary,
        HydrateFallback: () => null,
      },
    ],
  },
];
